import Api from "./Api";
import Csrf from "./Csrf";

export default {
  /*
  async getMenus(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/menus");
  },
  */

  async getOrdersSettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings");
  },

  async updateDeliverySettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/delivery", form);
  },

  async getDeliverySettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/delivery");
  },

  async updateTakeAwaySettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/takeaway", form);
  },

  async getTakeAwaySettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/takeaway");
  },

  async updateTableSettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/table", form);
  },

  async getTableSettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/table");
  },

  async updateUmbrellaSettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/umbrella", form);
  },

  async getUmbrellaSettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/umbrella");
  },

  async updateRoomServiceSettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/roomservice", form);
  },

  async getRoomServiceSettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/roomservice");
  },

  async getHotelSettings(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/orderssettings/hotel");
  },

  async updateHotelSettings(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/orderssettings/hotel", form);
  },
};
